import React from 'react';

const SvgBb = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BB_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="BB_svg__b">
        <stop stopColor="#1132C7" offset="0%" />
        <stop stopColor="#0522A5" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BB_svg__c" fill="#fff">
        <use xlinkHref="#BB_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BB_svg__a" />
      <path fill="url(#BB_svg__b)" mask="url(#BB_svg__c)" d="M0 0h28v20H0z" />
      <path
        fill="#08379D"
        mask="url(#BB_svg__c)"
        d="M13.333 0H28v20H13.333zM0 0h9.333v20H0z"
      />
      <path
        fill="#FFCC50"
        mask="url(#BB_svg__c)"
        d="M9.333 0h9.333v20H9.333z"
      />
      <path
        d="M13.838 6.278c.104-.153.275-.147.37 0l.944 1.444c.1.153.025.278-.157.278h-.323a.295.295 0 0 0-.305.332l.266 2.67a.38.38 0 0 0 .367.331.927.927 0 0 0 .574-.238l.185-.183a.912.912 0 0 0 .241-.576v-.664a.929.929 0 0 0-.24-.58l-.186-.185c-.133-.133-.097-.288.072-.344l1.375-.459c.172-.057.286.04.251.228l-.49 2.67c-.034.183-.17.436-.303.564l-.904.868a.969.969 0 0 1-.575.233.33.33 0 0 0-.333.336v.66a.331.331 0 0 1-.337.337h-.66a.331.331 0 0 1-.337-.336v-.66a.338.338 0 0 0-.333-.337.92.92 0 0 1-.566-.233l-.868-.868a1.274 1.274 0 0 1-.299-.564l-.534-2.67c-.037-.183.078-.284.246-.228l1.375.459c.173.057.209.208.072.344l-.185.186a.922.922 0 0 0-.241.579v.664c0 .186.104.44.24.576l.186.183a.952.952 0 0 0 .574.238.372.372 0 0 0 .367-.331l.266-2.67A.3.3 0 0 0 13.328 8h-.323c-.187 0-.25-.131-.15-.278l.983-1.444z"
        fill="#262626"
        mask="url(#BB_svg__c)"
      />
    </g>
  </svg>
);

export default SvgBb;
